// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__178Fh","tab":"ProcedureTabs_tab__2s5t8"};